// Used by craco.config.js (Node, so CommonJS): develop builds read the authentication URL at run time so
// `?auth_pr=<number>` can point them at an authentication PR deploy (see authPreview.js).

const AUTH_PR_GLOBAL = '__WOOSMAP_AUTH_PR__';

function authUrlExpression(apiBase, builtAuthUrl) {
    const pr = `window.${AUTH_PR_GLOBAL}`;
    return `(${pr} ? ${JSON.stringify(apiBase)} + "/" + ${pr} + "/auth" : ${JSON.stringify(builtAuthUrl)})`;
}

function pointAuthAtPullRequests(webpackConfig, apiBase, builtAuthUrl) {
    const define = webpackConfig.plugins.find((plugin) => plugin.constructor.name === 'DefinePlugin');
    if (!define) {
        throw new Error('No DefinePlugin in the webpack config: cannot point authentication at PR deploys.');
    }
    define.definitions['process.env'].REACT_APP_AUTH_URL = authUrlExpression(apiBase, builtAuthUrl);
}

module.exports = { AUTH_PR_GLOBAL, authUrlExpression, pointAuthAtPullRequests };
